export default {
    help: 'Helpdesk',
    options: {
        who_are_we: 'Who are we?',
        what_is_bookeraj: 'What is Bookeraj?',
        how_you_can_improve: 'How can we enhance your business?',
        companies: 'Companies',
        company_registration: 'Company registration and setup',
        company_users: 'Company user configuration',
        inactivity_setup: 'Inactivity setup',
        users: 'Users',
        user_profile_setup: 'Setting up user profile',
        offers: 'Services',
        create_offer: 'Create an service',
        offer_actions: 'Service actions',
        finding_offer: 'Finding services',
        chose: 'Please choose from the options...',
        create_discount: 'Create discount',
    },
}
